export enum ProfilePathsEnum {
  profilePage = '/profile',
}
